import { ref, watch, computed } from 'vue'
import Close from 'src/components/icons/close/Close.vue'
import { MdTypography } from '@antiqua-dls/vue-components'
import i18n from 'src/assets/i18n/i18n'
const { t } = i18n().global

export default {
    props: {
        overlaySec: {
            type: String,
            default: ''
        },
    },

    components: {
        Close,
        MdTypography
    },

    emits: ['close:OverlayInfo'],

    setup(props, {emit}) {
        const overlaySection = ref('')
        const overlayInfoSec = ref(null)

        const displayTitle = computed(() => {
            const titles = {
                foundryInformation: t('pages.profile.new_foundry.foundaryinfoheading'),
                contactInformation: t('pages.profile.new_foundry.contactinfoheading'),
                dei: t('pages.profile.new_foundry.dei_section.overlay_title'),
                foundryImagery: t('pages.profile.imageheading'),
            }
            return titles[overlaySection.value] || '';
        });

        const displayDesc = computed(() => {
            const descriptions = {
                contactInformation: t('pages.profile.new_foundry.contactInformationdesc'),
                dei: t('pages.profile.new_foundry.deiDesc'),
                foundryImagery: {
                    logo: t('pages.profile.new_foundry.foundryImageryDesc.logo'),
                    resolutionLogo: t('pages.profile.new_foundry.foundryImageryDesc.resolutionLogo'),
                    sizeLogo: t('pages.profile.new_foundry.foundryImageryDesc.sizeLogo'),
                    format:  t('pages.profile.new_foundry.foundryImageryDesc.format'),
                    banner: t('pages.profile.new_foundry.foundryImageryDesc.banner'),
                    resolutionBanner: t('pages.profile.new_foundry.foundryImageryDesc.resolutionBanner'),
                    sizeBanner: t('pages.profile.new_foundry.foundryImageryDesc.sizeBanner'),
                    desc: t('pages.profile.new_foundry.foundryImageryDesc.description')
                }
            }
            return descriptions[overlaySection.value] || '';
        })

        const closeOverlayInfo = () => {
            emit('close:OverlayInfo')
        }

        watch(
            () => props.overlaySec,
            (newValue) => {
                overlaySection.value = newValue
            },
            { immediate: true }
        )


        return {
            overlayInfoSec,
            overlaySection,
            displayTitle,
            displayDesc,
            closeOverlayInfo,
        }
    }
}